import ForbiddenActionMessage from './ForbiddenActionMessage'

export default ForbiddenActionMessage
